/*
 * The link that opens one isolate's dossier on Home: its row highlighted
 * (?hl=), its dialog open (?open=) on a tab (?tab=) -- IsolateHub's own
 * address, so a page elsewhere (My tasks, the Bank capabilities page, a
 * pipeline email) lands exactly where the hub would put it.
 */

/** Home with this isolate highlighted and opened on `tab` (none: the dialog's first). */
export function dossierLink(specimenId, tab) {
  const id = encodeURIComponent(specimenId);
  return `/?hl=${id}&open=${id}${tab ? `&tab=${encodeURIComponent(tab)}` : ''}`;
}
